import z from 'zod';

import { TeamId, UserId } from '../../BrandedIds';
import { zodTemporalInstant } from '../../Temporal';
import { CompanyRole, UserName } from '../../User';
import { lakeColumn } from '../util/lakeColumn';

export const ExportableUser = z
  .object({
    id: UserId,
    email: z.string(),
    ssoEmail: z.string().optional(),
    name: UserName.optional(),

    companyRole: CompanyRole,
    teams: lakeColumn(TeamId.array(), 'team_ids'),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'User' });
export type ExportableUser = z.infer<typeof ExportableUser>;
